import { Injectable } from '@angular/core';
import type { Components } from '@chefami-monorepo/ui-components/types';

type HTMLChefModalElement = HTMLElement & Components.ChefModal;

/**
 * Angular service wrapper for the chef-modal Stencil component.
 * Provides methods to open and close modals programmatically.
 */
@Injectable({ providedIn: 'root' })
export class ModalService {
  /**
   * Get a modal element by ID
   * @param id - The modal element ID
   */
  private getModal(id: string): HTMLChefModalElement | null {
    return document.getElementById(id) as HTMLChefModalElement | null;
  }

  /**
   * Open a modal by ID
   * @param id - The modal element ID
   */
  open(id: string): Promise<void> {
    return this.getModal(id)?.open() ?? Promise.resolve();
  }

  /**
   * Close a modal by ID
   * @param id - The modal element ID
   * @param reason - Optional reason for closing (default: 'method')
   */
  close(
    id: string,
    reason?: 'closeButton' | 'escape' | 'backdrop' | 'method'
  ): Promise<void> {
    return this.getModal(id)?.close(reason) ?? Promise.resolve();
  }
}
